import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import vuex from '../store/index';
import router from '../router';
import store from 'utils/store';
import { Notification } from 'element-ui';
const execptCode = [2016003, 2016004, 2016005, 2016006, 2016007]
Vue.use(VueAxios, axios);

axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  config => {
    const token = store.get('token');
    // console.log(token);
    config.headers.Accept = '*/*';
    // 请求头
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.AppCode = 'roses-platform';
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    if (response.data.code && response.data.code !== 200) {
      if (execptCode.includes(response.data.code)) {
        return response
      }
      Notification.error({
        title: response.data.code,
        message: response.data.message,
        duration: 3500
      });
    }
    return response;
  },
  error => {
    // console.log(error.response);
    Notification.error({
      title: error.response.status,
      message: error.response.statusText,
      duration: 3500
    });

    if (error.response.data.code === 520) {
      vuex.commit('SET_TOKEN', null);
      vuex.commit('SET_USER_INFO', null);
      router.replace('/login');
    }
    return Promise.reject(error);
  }
);
